import React from 'react';
import { MessageCard, i18n, tokens } from '@simplybenefits/sb-ui-library';

/**
 * BeneficiaryMessageCard - A component that displays messages related to beneficiary requirements
 * @param {Object} props - Component props
 * @param {Object} props.user - User object containing beneficiary requirement information
 * @returns {React.ReactElement|null} - The rendered component or null
 */
const BeneficiaryMessageCard = ({ user, hideBeneficiaryNotRequired = false }) => {
    const showRequiresBeneficiariesMessage = user.requiresBeneficiaries === true && user.hasBeneficiaries === false;
    const showBeneficiariesNotRequired = user.requiresBeneficiaries === false;
    const skipMessage = showBeneficiariesNotRequired && hideBeneficiaryNotRequired === true;

    if ((!showRequiresBeneficiariesMessage && !showBeneficiariesNotRequired) || skipMessage) {
        return null;
    }

    const title = showRequiresBeneficiariesMessage ? i18n.t(tokens.labels.employees.beneficiaryRequired) : 'Beneficiary Not Required';
    const subtitle = showRequiresBeneficiariesMessage ? i18n.t(tokens.labels.employees.addBeneficiary) : 'This member does not need to provide a beneficiary based on their current coverage.';

    return (
        <MessageCard
            title={ title }
            subtitle={ subtitle }
        />
    );
};

export default BeneficiaryMessageCard;